import React, {useCallback, useEffect, useLayoutEffect, useRef, useState} from 'react';
import {Bubble, ConfigProvider, Justify, SearchBox, Table, Button} from 'tea-component';
import {autotip, filterable, rowtooltip, scrollable, selectable, sortable} from 'tea-component/lib/table/addons';
import {useDebounceFn, useRequest} from 'ahooks';
import { getNewCategory, getNewDataTable } from '@dbl/services/dataSource';
import {checkNullString, formatNumberByComma, getLocalText} from '@/pages/datalab/utils/utils';
import {SortableColumn} from 'tea-component/es/table/addons';
import {ReactSortable} from 'react-sortablejs';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './join_select.scss';
import FilterSelectors from "@/pages/datalab/pages/Multidimensional/Analysis/components/HeaderData/FilterSelectors";
import BubbleEllipsis from "@/pages/datalab/components/BubbleEllipsis";

const sortColumns: SortableColumn[] = [{ key: 'use_count', prefer: 'desc' }];
const MAX_TABLE_NUM = 3;
// const {filterable, scrollable, autotip, sortable, selectable, rowtooltip} = Table.addons // 这种引用方式在打包构建之后会报错, 导致弹窗无法显示

interface Paginator {
  pageIndex: number;
  hasNext: boolean;
  total: number;
}

const CYCLE = 'cycle'; // 周期
const DRIVER = 'driver'; // 数据库
const LABEL = 'label'; // 一级类目
const SUB_LABEL = 'sub_label'; // 二级类目
const CATEGORIES = [LABEL, SUB_LABEL, DRIVER, CYCLE];
// 根据后端返回的中英映射, 获取文本
const createTranslateText = (translatorMap: any) => (key: string, value: string, isEn: boolean): string => {
  const map = translatorMap?.[key]?.[value];
  return map?.[isEn ? 'en' : 'zh'] || value || "-";
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
let translateText = (key: string, value: string, isEn: boolean) => '';

export const SourceSteep1 = (props: { gameCode: string; selectTables: any[]; setSelectTables: Function; selfJoin: boolean; setSelfJoin: Function; formatMessage: Function; commonFormatMessage: Function; openDetailModal: Function; isEn: boolean;}) => {
  const {
    gameCode,
    selectTables,
    setSelectTables,
    selfJoin,
    setSelfJoin,
    // eslint-disable-next-line react/prop-types
    formatMessage,
    // eslint-disable-next-line react/prop-types
    commonFormatMessage,
    // eslint-disable-next-line react/prop-types
    isEn,
    openDetailModal,
  } = props;

  const FILTER_ALL_VALUE = "__ALL__"; // 表头筛选的 ALL选项的值 必须是__ALL__才能做到 选中All, 表头是黑色

  const [sort, setSort] = useState<any>({by: 'use_count', order: 'desc'});
  const searchRef = useRef(null);
  const [checkBoxValue, setCheckBoxValue] = useState<string[]>([]);
  // 搜索框的输入值(受控, 即时更新)
  const [searchInputValue, setSearchInputValue] = useState<string | undefined>('');
  // 实际触发表格请求的搜索字段(防抖更新)
  const [searchWords, setSearchWords] = useState<string | undefined>('');
  const { run: debouncedSetSearchWords } = useDebounceFn(
    (value: string | undefined) => {
      setSearchWords(value);
    },
    { wait: 300 },
  );
  const paginatorRef = useRef<Paginator>({pageIndex: 1, hasNext: true, total: 0});
  // const [pageIndex, setPageIndex] = useState(1);
  const [filterValue, setFilterValue] = useState({}); // 类别筛选的值

  const requestDataRef = useRef(() => {});

  const {loading, error, runAsync} = useRequest(getNewDataTable, {
    manual: true,
  });
  const [records, setRecords] = useState([]);
  // 当前表周期
  const [curCycle, setCurCycle] = useState<string>(FILTER_ALL_VALUE);
  // 当前数据库
  const [driver, setDriver] = useState<string>(FILTER_ALL_VALUE);

  const [optionsMap, setOptionsMap] = useState<any>({[CYCLE]: [], [DRIVER]: [], [LABEL]: [], [SUB_LABEL]: []});

  // 计算生成options
  const createOptionsMap = (tabs: any, trans: any) => {
    try {
      const allOption = {text: commonFormatMessage('all'), value: 'all'};
      const map: any = {[LABEL]: [allOption], [SUB_LABEL]: [allOption], [DRIVER]: [], [CYCLE]: []};
      const hasOthersMap: any = {[LABEL]: false, [SUB_LABEL]: false, [DRIVER]: false, [CYCLE]: false};

      CATEGORIES.forEach((category) => {
        const valueMap = new Map();
        tabs?.forEach((tab: any = {}) => {
          const value = tab[category];

          if (!value) {
            hasOthersMap[category] = true;
          } else if (!valueMap.has(value)) {
            const text = trans[category]?.[value]?.[isEn ? 'en' : 'zh'] || trans[category]?.[value]?.zh || value;
            valueMap.set(value, {text, value});
          }

        });
        map[category].push(...valueMap.values());
      });

      for (const [category, hasOthers] of Object.entries(hasOthersMap)) {
        hasOthers && map[category].push({text: isEn ? 'Others' : '其他', value: ''});
      }

      setOptionsMap(map);
    } catch (e) {
      console.error('生成类目选项错误: ', e);
    }
  };

  // 请求类目信息
  useEffect(() => {
    getNewCategory({game_code: gameCode})
      .then((res) => {
        translateText = createTranslateText(res?.trans);
        createOptionsMap(res?.tabs, res?.trans);

      })
      .catch((e) => {
        console.log('类目请求错误: ', e);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameCode]);


  const buildSelectTable = useCallback(
    (oldValue: string[], newValue: string[]) => {
      if (selfJoin && (newValue?.length === 0 || newValue?.length === 2)) {
        // newValue.length === 0 是取消了自关联的数据表的勾选
        // newValue.length === 2 是勾选了其他数据表.
        // 以上两种情况都要取消自关联状态
        setSelfJoin(false);
        selectTables.pop();
      }
      const removeValues = oldValue.filter((value) => !newValue.includes(value));
      const addValues = newValue.filter((value) => !oldValue.includes(value));
      let newSelect = selectTables.filter((item) => !removeValues.includes(item.table_id));
      const addSelect: any[] = records.filter((item: any) => addValues.includes(item.table_id));
      newSelect = [...newSelect, ...addSelect];
      newSelect = newSelect.slice(Math.max(0, newSelect.length - MAX_TABLE_NUM), newSelect.length);
      setSelectTables(newSelect);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectTables, records],
  );

  const deleteSelectTable = (index: number) => {
    if (index < 0 || index >= selectTables.length) {
      return;
    }
    const newTables = [...selectTables];
    newTables.splice(index, 1);
    setSelectTables(newTables);
  };

  requestDataRef.current = (isAdd: boolean) => {
    if (!filterValue) {
      return;
    }
    const params = {
      game_code: gameCode,
      first_labels: filterValue.label,
      second_labels: filterValue.sub_label,
      drivers: driver !== FILTER_ALL_VALUE ? [driver] : undefined,
      cycles: curCycle !== FILTER_ALL_VALUE ? [curCycle] : undefined,
      keywords: searchWords,
      order_by: sort?.by,
      desc: sort?.order ? sort?.order === 'desc' : true,
      page: paginatorRef.current.pageIndex,
      page_size: 20,
    };

    runAsync(params)
      .then((res) => {
        const dataList = res?.data_list || [];
        if (dataList.length > 0) {
          setRecords((records) => isAdd ? records.concat(dataList) : dataList);
          paginatorRef.current.total = res?.row_count;
        }
      })
      .catch((e) => {
        console.log(e);
      }).finally(() => {
        paginatorRef.current.hasNext = true;
      });
  };


  useEffect(() => {
    paginatorRef.current = {pageIndex: 1, hasNext: true, total: 0};
    requestDataRef.current(false);
    setRecords([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameCode, filterValue, searchWords, JSON.stringify(sort), curCycle, driver]);

  useEffect(() => {
    // 主要是想排序，而不是过滤
    let newValue: string[] = [];
    if (checkBoxValue.length > 0) {
      newValue = newValue.concat(checkBoxValue.filter((value) => selectTables.some((item) => item?.table_id === value)));
    }
    newValue = newValue.concat(
      selectTables.filter((item) => !newValue.includes(item?.table_id)).map((item) => item?.table_id),
    );
    setCheckBoxValue(newValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectTables]);

  useEffect(() => {
    const newSelectTables = [...selectTables];
    newSelectTables.forEach((value, index) => {
      const newValue = records?.find((item: any) => item.table_id === value.table_id);
      newSelectTables[index] = newValue || value;
    });
    (JSON.stringify(selectTables) !== JSON.stringify(newSelectTables)) && setSelectTables(newSelectTables);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [records]);

  useLayoutEffect(() => {
    const element = document.querySelector('.add-source-table .tea-table__body');
    const handleScroll = () => {

      // 检查是否滚动到底部
      if (element?.scrollTop + element?.clientHeight >= element?.scrollHeight - 10) {

        if (paginatorRef.current.hasNext && (paginatorRef.current.pageIndex * 20 < paginatorRef.current.total)) {
          paginatorRef.current = {
            pageIndex: paginatorRef.current.pageIndex + 1,
            hasNext: false,
            total: paginatorRef.current.total
          };
          requestDataRef.current(true);
        }

      }
    };

    // 添加滚动监听事件
    element?.addEventListener('scroll', handleScroll);

    return () => {
      element?.removeEventListener('scroll', handleScroll);
    };

  }, []);



  const disableDifferentDatabase = (record: any) => {
    if (selectTables.length === 0) {
      return false;
    }
    const cmpDatabaseName = selectTables.find(task=>task?.db_name)?.db_name;
    return !(
      record.table_id === selectTables[0].table_id ||
      (!checkNullString(cmpDatabaseName) &&
        !checkNullString(record.db_name) &&
        record.db_name === cmpDatabaseName)
    );
  };

  const onlyOneTable = selectTables.length === 1;
  return (
    <>
      <Justify
        left={(<FilterSelectors
          labelOptions={optionsMap[LABEL]}
          subOptions={optionsMap[SUB_LABEL]}
          label={formatMessage('first_level')}
          subLabel={formatMessage('second_level')}
          setFilterValue={(category:string, value: any) => {
            JSON.stringify(filterValue[category]) !== JSON.stringify(value) &&
            setFilterValue({...filterValue, [category]: value});
          }}/>)}
        right={(<SearchBox
          searchBoxRef={searchRef}
          className="add-steep-search"
          multiline={false}
          value={searchInputValue}
          placeholder={formatMessage("search_placeholder")}
          onPressEnter={(value) => {
            setSearchWords(value);
          }}
          onChange={(value) => {
            setSearchInputValue(value);
            debouncedSetSearchWords(value);
          }}
          onSearch={(value) => {
            setSearchWords(value);
          }}
          onClear={() => {
            setSearchInputValue('');
            setSearchWords('');
          }}
        />)}

      />

      <ConfigProvider locale={isEn ? "en" : "zh"}>
        <Table
          records={records}
          bordered
          className="add-source-table"
          recordKey="table_id"
          columns={[
            {key: 'table_name', header: formatMessage("table_name"), width: 310, render(record){
              const name = getLocalText(isEn, record?.customize_name, record?.customize_name_en, record?.table_name);
              return (
                <>
                  <span className={'tea-text-overflow'} title={name}>{name}</span>
                  <Button type={'link'} onClick={() => {
                    openDetailModal({
                      resetProps: {
                        title: name,
                        isSingle: true,
                      },
                      tableIds: [record.table_id],
                      tableInfos: [{
                        connect_type: '',
                        customize_name: record.table_name,
                        customize_name_en: record.table_name,
                        granularity: record.cycle,
                        on: [],
                        table_code: 't0',
                        table_id: record.table_id,
                        table_name: record.table_name,
                      }],
                      dataTables: [{
                        table_id: record.table_id,
                        table_code: 't0',
                        driver: record.driver,
                        database_uuid: record.database_uuid,
                      }],
                    });
                  }}>{commonFormatMessage('detail')}</Button>
                </>
              );
            }},
            {
              key: 'table_desc', header: formatMessage("table_description"), width: 356,
              render: (record) => {
                const content = isEn ? (record?.table_desc_en || record?.table_desc) : record?.table_desc;
                return content ? (<BubbleEllipsis
                  content={content}
                  className={'add-source-table-desc-bubble'}
                />) : '-';
              }
            },
            {
              key: 'use_count', header: formatMessage("usage_count"), align: 'right', width: 140, render(record) {
                return formatNumberByComma(record?.use_count) || '-';
              }
            },
            {
              key: 'cycle', header: formatMessage("table_cycle"), width: 150, render(record) {
                return translateText('cycle', record?.cycle, isEn);
              }
            },
            {
              key: 'driver',
              header: formatMessage('table_database'),
              width: 155,
              align: 'left',
              render(record) {
                return translateText('driver', record?.driver, isEn);
              }
            },
            {
              key: 'db_name',
              header: formatMessage('database_name'),
              width: 240,
              align: 'left',
              render: (record) => {
                const content = `${record.db_name}${ record.scheme ? `(${record.scheme})` : ''  }`;
                return content ? (<BubbleEllipsis
                  content={content}
                  className={'add-source-table-desc-bubble'}
                />) : '-';
              }
            },

          ]}
          rowDisabled={(record) => record.sync_status === 1}
          addons={[
            // 支持表格滚动，高度超过 192 开始显示滚动条
            scrollable({
              maxHeight: selectTables.length > 0 ?  477 : 522,
              // minHeight:400,
              // onScrollBottom: (event) => {
              // 因为 表格浮窗滚动 会触发 onScrollBottom, 但是编译构建发到环境上时, event.target是null, 无法判断是哪个元素触发的, 所以不能用这个方法
              //   // event.target?.className === 'tea-table__body' 避免弹窗内部滚动时触发表格请求
              //   if (event.target?.className === 'tea-table__body' && paginatorRef.current.hasNext && (paginatorRef.current.pageIndex * 20 < paginatorRef.current.total)) {
              //     paginatorRef.current = {
              //       pageIndex: paginatorRef.current.pageIndex + 1,
              //       hasNext: false,
              //       total: paginatorRef.current.total
              //     };
              //     requestData(true);
              //   }
              // },
            }),
            selectable({
              // 选框放在「消息类型」列上
              targetColumnKey: 'table_name',
              // 禁用全选
              all: false,
              // 已选中的键值
              value: checkBoxValue,
              // 选中键值发生变更
              onChange: (value) => {
                buildSelectTable(checkBoxValue, value);
                setCheckBoxValue(value);
              },
              render: (element, context) => {
                const {rowKey, record} = context;
                const disableForDatabase = disableDifferentDatabase(record);

                return !disableForDatabase &&
                (selectTables.length < 3 || selectTables.find((item) => item.table_id === rowKey)) ? (
                    element
                  ) : (
                    <Bubble dark={true} className={'add-source-table-name-bubble'}
                      content={disableForDatabase ? formatMessage("not_same") : formatMessage("more_then_three")}>
                      {element}
                    </Bubble>
                  );
              },
              // false=>禁用 true=>开启
              rowSelectable: (rowKey: string, context) => {
                const {record} = context;
                if (disableDifferentDatabase(record)) {
                  return false;
                }
                return selectTables.length < 3 || selectTables.find((item) => item.table_id === rowKey);
              },
            }),
            sortable({
              columns: sortColumns,
              value: [sort],
              onChange: (value: any[], context) => {
                // 如果value数组没有元素说明当前是未排序状态, 那么上传给后端的参数就应该是按照创建时间降序排序
                const sort = value?.length > 0 ? context.sort : {by: 'table_name', order: undefined};
                setSort(sort);
              },
            }),
            autotip({
              isLoading: loading,
              isError: !!error,
              loadingText: commonFormatMessage("loading"),
              errorText: (
                <span>
                  {commonFormatMessage("load_fail")}
                  {/* <Text theme="primary" onClick={() => requestData()}>*/}
                  {/*  {commonFormatMessage("refresh")}*/}
                  {/* </Text>*/}
                </span>
              ),
              emptyText: commonFormatMessage("no_data"),
              // emptyText: searchWords ? (
              //   <div>
              //     <Text>{commonFormatMessage("not_search")}</Text>
              //     <Text
              //       theme="primary"
              //       onClick={() => {
              //         setSearchWords('');
              //         setCurCycle('');
              //       }}
              //       style={{cursor: 'pointer'}}
              //     >
              //       {commonFormatMessage("go_back_old")}
              //     </Text>
              //   </div>
              // ) : commonFormatMessage("no_data"),
              style: {lineHeight: '482px'},
            }),
            filterable({
              type: 'single',
              column: 'cycle',
              value: curCycle,
              onChange: (value) => {
                setCurCycle(value);
              },
              // 选项列表
              options: optionsMap[CYCLE],
              all: {text: commonFormatMessage('all'), value: FILTER_ALL_VALUE}
            }),
            filterable({
              type: 'single',
              column: 'driver',
              value: driver,
              onChange: (value) => {
                setDriver(value);
              },
              // 选项列表
              options: optionsMap[DRIVER],
              all: {text: commonFormatMessage('all'), value: FILTER_ALL_VALUE}
            }),
            rowtooltip({
              tooltip: (record) =>
                record.sync_status === 1 ? (
                  <div style={{padding: "10px 14px"}}>{formatMessage("tooltip")}</div>) : null,
            }),
            // injectable({
            //   head: (props) => {
            //     return {
            //       className: 'ddd'
            //     }
            //   }
            // })
          ]}
        />
      </ConfigProvider>

      <ReactSortable
        setList={(newValue: any[]) => {
          setSelectTables(newValue);
        }}
        className="footer-flex join-select-sortable"
        list={selectTables}
        handle={'.data-label-tips'}
        animation={150}
        delay={100}
        forceFallback={true}
        style={{display: `${selectTables.length === 0 ? 'none' : ''}`}}
      >
        {selectTables.map((it, index) => {
          const title = getLocalText(isEn, it?.customize_name, it?.customize_name_en, it?.table_name);
          return (
            <div className="data-label-tips join-mgr-modal-select-cell-container" key={it?.table_id + index}>
              {/* 数据循环时候数据结构在这 */}
              <div className="footer-item">
                {onlyOneTable ? '' : (<div className="footer-num">{`t${index}`}</div>)}
                <div className={`footer-text ${onlyOneTable ? 'footer-not-num' : ''}`} title={title}>
                  <span className={'tea-text-overflow'}>{title}</span>
                  <Button type={'link'} onClick={() => {
                    openDetailModal({
                      resetProps: {
                        title,
                        isSingle: true,
                      },
                      tableIds: [it.table_id],
                      tableInfos: [{
                        connect_type: '',
                        customize_name: it.customize_name,
                        customize_name_en: it.customize_name_en,
                        granularity: it.cycle,
                        on: [],
                        table_code: 't0',
                        table_id: it.table_id,
                        table_name: it.table_name,
                      }],
                      dataTables: [{
                        table_id: it.table_id,
                        table_code: 't0',
                        driver: it.driver,
                        database_uuid: it.database_uuid,
                      }],
                    });
                  }}>{commonFormatMessage('detail')}</Button>
                </div>
                <div
                  onClick={() => {
                    deleteSelectTable(index);
                    // 自关联的情况下, 删除任意表格代表取消自关联状态.
                    selfJoin && setSelfJoin(false);
                  }}
                >
                  <SvgIcon type="clonse" className="footer-icon" />
                </div>
              </div>
            </div>
          );
        } )}
      </ReactSortable>
    </>
  );
};
